import { render, staticRenderFns } from "./dragModal.vue?vue&type=template&id=1a60f655&scoped=true"
import script from "./dragModal.vue?vue&type=script&lang=js"
export * from "./dragModal.vue?vue&type=script&lang=js"
import style0 from "./dragModal.vue?vue&type=style&index=0&id=1a60f655&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a60f655",
  null
  
)

export default component.exports